module.exports = __webpack_public_path__ + "static/media/app-screen.1c36315d.png";